import React from "react";
import Sidenav from "../components/driver_includes/Sidenav";
import Topbar from "../components/driver_includes/Topbar";

import "./vendor/fontawesome-free/css/all.min.css";
import "./vendor/stylesheets/sb-admin-2.min.css";
import "./vendor/datatables/dataTables.bootstrap4.min.css";

class Driverorders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_id: "",
      data: [],
    };
    this.replyOrder=this.replyOrder.bind(this)
  }

  componentDidMount() {
    let driverid = JSON.parse(localStorage.getItem("logisticsuser"));

    if (driverid) {
      this.setState({
        drivers_id: driverid.id,
      });
  
      fetch(
        `https://webappexpressnew.herokuapp.com/driver/currenttrip/${driverid.id}`
      )
        .then((response) => response.json())
        .then((fetchData) => {
          console.log(fetchData);
          this.setState({ data: fetchData.response });
        });
      
    }


    console.log(this.state, "state");
  }

  fetchdata() {}

  async replyOrder(reply,drivers_id,order_id) {
    console.log(reply,drivers_id, order_id);
    let body={reply,driver_id:drivers_id, order_id}
    console.log(body);
    let result = await fetch(
      "https://webappexpressnew.herokuapp.com/driver/replytrip",
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    let response = await result.json();
    console.log(response);
  }
  render() {
    if (this.state.data.length > 0) {
      let customerReq = this.state.data[0];
      console.log(this.state.data, "fhjdfdfhdfjjdfhfjdjfd");
      return (
        <div>
          <div id="page-top">
            <div id="wrapper">
              <Sidenav />

              <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                  <Topbar />

                  <div className="container-fluid">
                    <div className="card shadow mb-4">
                      <br />
                      <h1 className="h3 mb-2 text-gray-800 text-center">
                        Current Trip Order
                      </h1>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-4">
                            <div
                              className="card text-center"
                              style={{ margin: 20 }}
                            >
                              <br />
                              <img
                                src="https://res.cloudinary.com/ckgraphics/image/upload/v1641005399/undraw_profile_pic_ic5t_rkejzu.png"
                                className="card-img-top"
                                alt="..."
                              />
                              <div className="card-body text-dark">
                                <p className="card-text fs-4 text-capitalize ">
                                  {customerReq.product_name}
                                </p>
                                <p className="card-text fs-4">
                                  {customerReq.phone}
                                </p>
                                <p className="card-text fs-4">
                                  {customerReq.weight}Kg
                                </p>
                                <h5 className="card-title fs-4 text-capitalize">
                                  Pickup Address:{" "}
                                  {this.state.data[0].pick_address}
                                </h5>
                                <button className="btn btn-success def-btn fs-6"
                                onClick={this.replyOrder.bind(this,'accept',this.state.drivers_id, customerReq.order_id)}>
                                  Accept Trip
                                </button>
                                <br />
                                <br />
                                <button className="btn btn-danger def-btn fs-6">
                                  Cancel Trip
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <a className="scroll-to-top rounded" href="#page-top">
              <i className="fas fa-angle-up"></i>
            </a>

            <div
              className="modal fade"
              id="logoutModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Ready to Leave?
                    </h5>
                    <button
                      className="close"
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    Select "Logout" below if you are ready to end your current
                    session.
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      type="button"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <a className="btn btn-primary" href="login.html">
                      Logout
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }else if(this.state.data.length===0){
      return(
        <div>
          <div>
            <div id="page-top">
              <div id="wrapper">
                <Sidenav />

                <div id="content-wrapper" className="d-flex flex-column">
                  <div id="content">
                    <Topbar />

                    <div className="container-fluid">
                      <div className="card shadow mb-4 text-center">
                        <br />
                        <div className="card-body">
                        <h1 className="h3 mb-2 text-gray-800 text-center text-warning">
                          No Trip available at the moment
                        </h1>

                          <div
                            class="spinner-grow text-secondary"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
              </a>

            </div>
          </div>
        </div>
      )
    } 
    
    else {
      return (
        <div>
          <div>
            <div id="page-top">
              <div id="wrapper">
                <Sidenav />

                <div id="content-wrapper" className="d-flex flex-column">
                  <div id="content">
                    <Topbar />

                    <div className="container-fluid">
                      <div className="card shadow mb-4 text-center">
                        <br />
                        <h1 className="h3 mb-2 text-gray-800 text-center">
                          Current Trip Order
                        </h1>
                        <div className="card-body">
                          <h1>Loading </h1>
                          <div
                            class="spinner-grow text-secondary"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
              </a>

              <div
                className="modal fade"
                id="logoutModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Ready to Leave?
                      </h5>
                      <button
                        className="close"
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      Select "Logout" below if you are ready to end your current
                      session.
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        type="button"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <a className="btn btn-primary" href="login.html">
                        Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Driverorders;
